import { Component, EventEmitter, Output, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { UploadState } from './upload-dialog-base';

@Component({
    selector: 'upload-dialog-action-buttons',
    template: require('./upload-dialog-action-buttons.component.html')
})
export class UploadDialogActionButtonsComponent {
    @Input()
    public editorForm: FormGroup;

    @Input()
    public uploadState: UploadState;

    @Output()
    public add = new EventEmitter<void>();

    @Output()
    public close = new EventEmitter<void>();

    public get isBusy(): boolean {
        return this.uploadState === UploadState.inProgress;
    }

    public get successUpload(): boolean {
        return this.uploadState === UploadState.SuccessUpload;
    }

    public get closeLabel(): string {
        return this.successUpload ? 'Close' : 'Cancel';
    }
}
